/* eslint-disable no-unused-vars */
import {
    requestMethod,
    requestDuration,
    requestType
} from '@/util/components/request.js'
/* eslint-disable no-unused-vars */

export default {
    // 登录
    login: {
        url: 'login',
        method: requestMethod.POST,
        qs: true
    },
    // 管理员
    admin_manager: {
        get: {
            url: 'userlist',
            method: requestMethod.POST,
            qs: true
        },
        edit: {
            url: 'usercreate',
            method: requestMethod.POST,
            qs: true
        },
        del: {
            url: 'userdel',
            method: requestMethod.POST,
            qs: true
        }
    },
    // 角色
    admin_role: {
        get: {
            url: 'roleindex',
            method: requestMethod.POST,
            qs: true
        },
        edit: {
            url: 'roleadd',
            method: requestMethod.POST,
            qs: true
        },
        del: {
            url: 'roleddel',
            method: requestMethod.POST,
            qs: true
        }
    },
    // 订单
    order: {
        get: {
            url: 'getindent',
            method: requestMethod.POST,
            qs: true
        },
        edit: {
            url: 'saveindent',
            method: requestMethod.POST,
            qs: true
        },
        detail: {
            url: 'indexdetails',
            method: requestMethod.POST,
            qs: true
        },
        group_price: {
            url: 'getgrouping',
            method: requestMethod.POST,
            qs: true
        },
        returns: {
            url: 'refund',
            method: requestMethod.POST,
            qs: true
        },
        repay: {
            url: 'indexwrite',
            method: requestMethod.POST,
            qs: true
        },
        throwd: {
            url: 'saveindenttype',
            method: requestMethod.POST,
            qs: true
        },
        deletes: {
            url: 'delindent',
            method: requestMethod.POST,
            qs: true
        },
        defaultGoods: {
            url: 'getisgoods',
            method: requestMethod.POST,
            qs: true
        },
        statData: {
            url: 'countorder',
            method: requestMethod.GET,
            qs: false
        }
    },
    // 营销管理
    card: {
        get: {
            url: 'getclip',
            method: requestMethod.POST,
            qs: true
        },
        edit: {
            url: 'creatclip',
            method: requestMethod.POST,
            qs: true
        },
        activeCard: {
            url: 'allocationclip',
            method: requestMethod.POST,
            qs: true
        },
        activeSellerCard: {
            url: 'fpkh',
            method: requestMethod.POST,
            qs: true
        },
        getType: {
            url: 'getcliptype',
            method: requestMethod.POST,
            qs: true
        },
        editType: {
            url: 'createcliptype',
            method: requestMethod.POST,
            qs: true
        },
        getSellCard: {
            url: 'clitype',
            method: requestMethod.POST,
            qs: true
        },
        editSellCard: {
            url: 'saveclitype',
            method: requestMethod.POST,
            qs: true
        },
        getCardPrefix: {
            url: 'getprefix',
            method: requestMethod.POST,
            qs: true
        },
        getCardSeller: {
            url: 'getdealer',
            method: requestMethod.POST,
            qs: true
        },
        getAllCardSeller: {
            url: 'getalldealer',
            method: requestMethod.POST,
            qs: true
        },
        bindSellerAccount: {
            url: 'binddealer',
            method: requestMethod.POST,
            qs: true
        },
        getCardUser: {
            url: 'getweix',
            method: requestMethod.POST,
            qs: true
        },
        refuseReturn: {
            url: 'cancelcard',
            method: requestMethod.POST,
            qs: true
        }
    },
    // 分组管理
    group: {
        get: {
            url: 'getassemble',
            method: requestMethod.POST,
            qs: true
        },
        edit: {
            url: 'saveassemble',
            method: requestMethod.POST,
            qs: true
        },
        del: {
            url: 'delassemble',
            method: requestMethod.POST,
            qs: true
        },
        guest_get: {
            url: 'getclity',
            method: requestMethod.POST,
            qs: true
        },
        guest_edit: {
            url: 'saveprice',
            method: requestMethod.POST,
            qs: true
        }
    },
    // 商品信息
    goods: {
        get: {
            url: 'getgoods',
            method: requestMethod.POST,
            qs: true
        },
        edit: {
            url: 'savegoods',
            method: requestMethod.POST,
            qs: true
        },
        del: {
            url: 'delgoods',
            method: requestMethod.POST,
            qs: true
        },
        getByGroup: {
            url: 'groubxq',
            method: requestMethod.GET,
            qs: false
        }
    },
    // 客户资料
    guest_source: {
        get: {
            url: 'clientlist',
            method: requestMethod.POST,
            qs: true
        },
        edit: {
            url: 'saveclient',
            method: requestMethod.POST,
            qs: true
        },
        del: {
            url: 'delclient',
            method: requestMethod.POST,
            qs: true
        }
    },
    // 客户押金
    guest_deposit: {
        get: {
            url: 'getdeposit',
            method: requestMethod.POST,
            qs: true
        }
    },
    // 统计数据
    statistic: {
        get: {
            url: 'getdataall',
            method: requestMethod.POST,
            qs: true
        },
        getA: {
            url: 'getgas',
            method: requestMethod.GET,
            qs: false
        },
        getATotal: {
            url: 'getgascount',
            method: requestMethod.GET,
            qs: false
        },
        // getB: {
        //     url: 'getdataall',
        //     method: requestMethod.GET,
        //     qs: false
        // },
        getC1: {
            url: 'debtor',
            method: requestMethod.GET,
            qs: false
        },
        getC2: {
            url: 'nodebtor',
            method: requestMethod.GET,
            qs: false
        },
        getCTotal: {
            url: 'debtorcount',
            method: requestMethod.GET,
            qs: false
        },
        getD: {
            url: 'getcollect',
            method: requestMethod.GET,
            qs: false
        }
    },
    // 车辆管理
    vehicle: {
        get: {
            url: 'getvehicle',
            method: requestMethod.POST,
            qs: true
        },
        edit: {
            url: 'savevehicle',
            method: requestMethod.POST,
            qs: true
        },
        del: {
            url: 'delvehicle',
            method: requestMethod.POST,
            qs: true
        },
        getName: {
            url: 'getname',
            method: requestMethod.POST,
            qs: true
        }
    },
    // 区域管理
    area: {
        get: {
            url: 'getarea',
            method: requestMethod.POST,
            qs: true
        },
        edit: {
            url: 'savearea',
            method: requestMethod.POST,
            qs: true
        },
        del: {
            url: 'delarea',
            method: requestMethod.POST,
            qs: true
        }
    },
    // 日志
    log: {
        get: {
            url: 'getlogo',
            method: requestMethod.POST,
            qs: true
        }
    },
    // 客户类型
    guest_type: {
        get: {
            url: 'postClienttype',
            method: requestMethod.POST,
            qs: true
        }
    },
    // 导出
    exports: {
        url: 'export',
        method: requestMethod.GET,
        qs: false
    }
}
